import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const bouncy: Partial<CaptionStyles> = {
  theme_preset: 'bouncy',
  pageStyle: {
    WebkitTextStrokeWidth: '12px',
    WebkitTextStrokeColor: '#000000',
    paintOrder: 'stroke',
    textShadow: '10px 10px 15px #000000',
    color: '#fff700'
  },
  wordStyle: {
    inactive: {
      color: '#fff700'
    },
    highlightType: HighlightTypeEnum.None
  },
  letterStyle: undefined,
  font_location: getFontFullPath('Bangers-Regular.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneWord,
  font_size: 144,
  transitions: {
    pageIn: TransitionInEffect.Spring
  }
};

export default bouncy;
